import React from "react";
import { RenderKilogramo } from "Utils/renderField/renderReadField";
import "../styles/ResumenFisicoPadresPT.css";

const DatoResumen = ({ etiqueta, kg, esTotal }) => (
    <div
        className={`resumen-fisico__dato ${
            esTotal ? "resumen-fisico__dato--total" : ""
        }`}
    >
        <label className="resumen-fisico__etiqueta pl-0">{etiqueta}</label>
        <span className="resumen-fisico__valor">
            <RenderKilogramo value={kg} decimalScale={2} />
        </span>
    </div>
);

// Inventario físico del cierre agrupado por padre de producto terminado, con
// el total general al final. Los padres los define el backend: son los que
// tienen filas en el cierre, así que ver los productos sin movimientos no
// agrega ninguno
export const ResumenFisicoPadresPT = ({ resumen = [] }) => {
    if (!resumen || resumen.length === 0) return null;

    const totalGeneral = resumen.reduce(
        (acumulado, padre) => acumulado + Number(padre.kg_fisico || 0),
        0,
    );

    return (
        <div className="resumen-fisico">
            <div className="resumen-fisico__datos">
                {resumen.map((padre) => (
                    <DatoResumen
                        key={padre.padre_producto_terminado_id}
                        etiqueta={
                            padre.padre_producto_terminado_nombre ||
                            "Sin nombre"
                        }
                        kg={padre.kg_fisico}
                    />
                ))}

                <DatoResumen
                    etiqueta="Total general"
                    kg={totalGeneral}
                    esTotal
                />
            </div>
        </div>
    );
};
